import { StatusColors } from '@nexelem/components';
import { QueueStatus } from '@nexelem/graphne-api';

const mapping: Record<QueueStatus, StatusColors> = {
  [QueueStatus.InProgress]: 'blue',
  [QueueStatus.Idle]: 'grey',
  [QueueStatus.Break]: 'grey',
  [QueueStatus.Error]: 'red',
};

export const getQueueStatusColor = (status: QueueStatus): StatusColors => mapping[status];
